import { Injectable } from '@angular/core';
import { HTTP } from '@ionic-native/http/ngx';
import { BaseService } from 'src/app/arquitetura/service/base.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ComissaoService extends BaseService {

  constructor(http: HTTP) {
    super('', http);
  }

  obter(token: string, accountId: number){
    return this.http.get(`${environment.api}v1/get-comission-percentage?token=${token}&accountId=${accountId}`, null, this.config()).then(data => JSON.parse(data.data));
  }
}